import { queries } from "../../shared/queries";
import {
  displayStepConfig,
  isConnectorRouteAuth,
  stepDirFromPath,
} from "../../shared/stepConfig";
import { useQuery } from "@rocicorp/zero/react";

// True when the given branch (or main when branchId is omitted) has at least one
// route marked route_auth = "connector". Used to hint that the workflow should
// be set up as a connector.
export function useHasExposedConnectorRoutes(
  workflowId: string,
  branchId: string | undefined,
  enabled = true
): boolean {
  const [workflow] = useQuery(
    enabled
      ? queries.workflowBranchRoutes({
          workflowId,
          ...(branchId && { branchId }),
        })
      : undefined
  );

  const head = workflow?.branches?.headCommit;
  const exposedStepDirs = new Set<string>();
  for (const f of head?.files ?? []) {
    const stepDir = stepDirFromPath(f.path);
    if (!stepDir) continue;
    const content = f.blob?.content;
    if (typeof content !== "string") continue;
    if (isConnectorRouteAuth(displayStepConfig(content).routeAuth)) {
      exposedStepDirs.add(stepDir);
    }
  }
  return (head?.routes ?? []).some((r) => exposedStepDirs.has(r.stepDir));
}
